import { useEffect, useRef, useState } from "react";
import { useIntersectionObserver } from "usehooks-ts";

import { getDispensaryUpdates } from "@/api/requests/getDispensaryUpdates";
import { Update } from "@/custom-types/Update";

const useDispensaryUpdates = (slug: string, perPage = 3) => {
  const [page, setPage] = useState(1);
  const [updates, setUpdates] = useState<Update[]>();

  const { ref, isIntersecting } = useIntersectionObserver({
    freezeOnceVisible: true,
  });

  const totalCount = useRef<number>(0);
  useEffect(() => {
    if (isIntersecting) {
      const getUpdates = async () => {
        const { data, metadata } = await getDispensaryUpdates(
          slug,
          perPage * (page - 1),
          perPage,
        );

        if (totalCount.current === undefined) {
          totalCount.current = metadata.totalCount;
        }
        setUpdates(updates ? [...updates, ...data] : data);
      };

      getUpdates();
    }
  }, [isIntersecting, page, slug]);

  return {
    page,
    ref,
    setPage,
    totalCount: totalCount.current || 0,
    updates,
  };
};

export default useDispensaryUpdates;
